import { createContext, ReactNode, useContext } from "react";

interface IndexProviderProps {
  id: string;
  children: ReactNode;
}

interface IndexContextValue {
  id: string;
}

const IndexContext = createContext<IndexContextValue | undefined>(undefined);

const IndexProvider: React.FC<IndexProviderProps> = ({ id, children }) => {
  return (
    <IndexContext.Provider value={{ id }}>{children}</IndexContext.Provider>
  );
};

const useIndexContext = (): IndexContextValue => {
  const context = useContext(IndexContext);
  if (!context)
    throw new Error("useIndexContext must be used within IndexProvider");
  return context;
};

export { IndexProvider, useIndexContext };
